import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {I18n, setLocale} from 'react-redux-i18n';

import { Modal, Form, Input, Button, Spin, Select, message } from 'antd';

import * as ToolRequest from '../../tools/ToolRequest';
import SpinFull from '../../components/SpinFull';
import * as ToolUser from "../../tools/ToolUser";
import {updateUser} from "../../reducers/userSlice";

const formLayout = {
  labelCol: {
    md: { span: 5 },
    sm: { span: 24 },
  },
  wrapperCol: {
    md: { span: 16 },
  },
};

const formTailLayout = {
  wrapperCol: {
    md: { offset: 5, span: 16 },
  },
};

const { TextArea } = Input;
const { Option } = Select;

export default function UserSettingModal(props) {
  const { visible, onOk, onCancel } = props;
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.value);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {

      } catch (err) {
      }

      setLoaded(true);
    })();
  }, []);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const data = {
        fullName:values.fullName
      };
      await ToolRequest.request('PUT', `/user/${user.id}`, data);

      const userDataRes = await ToolRequest.request('GET', '/user/me');
      dispatch(updateUser(userDataRes.data));

      message.success(I18n.t('editSuccessMessage'));

      onOk();
      setLoading(false);
    } catch (err) {
      setLoading(false);

      if (err?.response?.data) {
        switch (err.response.data) {
          default:
            return message.error(I18n.t('errorMessageUnknownError'));
        }
      }

      message.error(I18n.t('errorMessageUnknownError'));
    }
  };

  return (
    <Modal
      title={I18n.t('個人設定')}
      visible={visible}
      onCancel={onCancel}
      width="50%"
      maskClosable={false}
      footer={null}
    >
      {loaded ? (
        <Spin spinning={loading}>
          <Form
            {...formLayout}
            initialValues={user}
            onFinish={onFinish}
          >
            <Form.Item
              label={I18n.t('全稱')}
              name="fullName"
            >
              <Input
                placeholder={I18n.t('全稱')}
              />
            </Form.Item>

            <Form.Item {...formTailLayout}>
              <Button type="primary" htmlType="submit" block>
                {I18n.t('提交')}
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      ) : <SpinFull />}
    </Modal>
  );
};